import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import bronzeImage from './images/bronze.png';
import goldImage from './images/gold.png';
import silverImage from './images/silver.png';
import platinumImage from './images/platinum.png';
//import { OwnListingLink } from'../../../../components';

import css from './SectionSATiers.module.css';

const SectionSATiers = props => {
  const { rootClassName, className } = props;

  const classes = clsx(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionSATiers.titleLineOne" />
        <br />
      </div>
      <div className={css.standard}>
        <strong>
          <FormattedMessage id="SectionSATiers.standardBold" />
        </strong>

        <FormattedMessage id="SectionSATiers.standardText" />
      </div>
      <div className={css.steps}>
        <div className={css.step}>
          <img className={css.medal} src={bronzeImage} alt="bronze logo" />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionSATiers.bronzeTitle" />
          </h2>
          <p>
            <FormattedMessage id="SectionSATiers.bronzePercentage" />
          </p>
          <p>
            <FormattedMessage id="SectionSATiers.bronzeText" />
          </p>
        </div>

        <div className={css.step}>
          <img className={css.medal} src={silverImage} alt="silver logo" />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionSATiers.silverTitle" />
          </h2>
          <p>
            <FormattedMessage id="SectionSATiers.silverPercentage" />
          </p>
          <p>
            <FormattedMessage id="SectionSATiers.silverText" />
          </p>
        </div>

        <div className={css.step}>
          <img className={css.medal} src={goldImage} alt="golden logo" />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionSATiers.goldTitle" />
          </h2>
          <p>
            <FormattedMessage id="SectionSATiers.goldPercentage" />
          </p>
          <p>
            <FormattedMessage id="SectionSATiers.goldText" />
          </p>
        </div>
        <div className={css.step}>
          <img className={css.medal} src={platinumImage} alt="platinum logo" />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionSATiers.platinumTitle" />
          </h2>
          <p>
            <FormattedMessage id="SectionSATiers.platinumPercentage" />
          </p>
          <p>
            <FormattedMessage id="SectionSATiers.platinumText" />
          </p>
        </div>
      </div>
    </div>
  );
};

SectionSATiers.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionSATiers.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionSATiers;
